import React, { useState, useEffect } from 'react';
import useDark from 'use-dark';

import img1Src from '../assets/dark.jpg';
import img2Src from '../assets/dark2.jpg';
import img3Src from '../assets/dark4.jpg';

const images = [img1Src, img2Src, img3Src];

function DarkSimple() {
  const [index, setIndex] = useState(0);
  const ref = useDark(images[index]);

  useEffect(() => {
    const i = setInterval(() => {
      setIndex((c) => (c < images.length - 1 ? c + 1 : 0));
    }, 5000);
    return () => clearInterval(i);
  }, []);

  return (
    <header className="header">
      <canvas className="canvas" ref={ref} />
    </header>
  );
}

export default DarkSimple;
